export const API_LIVE_URL = "https://api.bonusnow.iosx.in";
